import React, { useContext, useRef } from "react";

import FormikForm from "../../forms/FormikForm";
import VerifyCode from "./VerifyCode";
import { LoginContext } from "./LoginContainer";
import { CredentialsCard } from "./CredentialsCard";
import { usePrevious } from "../../hooks/usePrevious";

export const LoginForm = () => {
  const formikPropsRef = useRef();
  const {
    onSubmit,
    defaultEmail,
    scopeId,
    verifyTwoFactor,
    sentToEmail,
  } = useContext(LoginContext);

  const prevScopeId = usePrevious(scopeId);

  if (verifyTwoFactor) {
    return <VerifyCode isEmail={sentToEmail} />;
  }

  if (prevScopeId !== scopeId) {
    formikPropsRef.current.setFieldValue("scopeId", scopeId);
  }

  return (
    <FormikForm
      initialValues={{
        email: defaultEmail,
        password: "",
        scopeId,
      }}
      onSubmit={onSubmit}
    >
      {({ handleSubmit, values, errors, ...formikProps }) => {
        formikPropsRef.current = formikProps;
        return (
          <CredentialsCard
            formikProps={{ ...formikProps, handleSubmit, values, errors }}
          />
        );
      }}
    </FormikForm>
  );
};

LoginForm.propTypes = {};
